import React from "react";
import { formatDate } from "../../helpers"
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from 'gatsby-background-image'
const BlogPostHero = ({ blogPost }) => {
    const image = getImage(blogPost?.heroImage?.asset?.gatsbyImageData);
    const bgImage = convertToBgImage(image)
    return (
        <BackgroundImage
            Tag="section"
            {...bgImage}
            preserveStackingContext
        >
            <div className="homepage-hero bg-center bg-cover bg-no-repeat flex items-end justify-end relative">
                <div className="lg:w-1/2 w-11/12 bg-blog-area py-8 px-12 mx-auto -mb-32 relative z-20">
                    <div className="flex justify-center">
                        <p className="text-base text-center font-semibold border-b-2 border-yellow-400 text-black uppercase">{blogPost?.blogCategory?.name || ""}</p>
                    </div>
                    <h1 className="text-center text-xl lg:text-5xl leading-normal text-black">{blogPost?.title || ""}</h1>
                    <div className="flex items-center justify-center">
                        <p className="text-xs text-center text-gray-500 font-semibold mt-8 uppercase mr-4">{blogPost?.readTime} read</p>
                        <p className="text-xs text-center text-gray-500 font-semibold mt-8 uppercase">{formatDate(blogPost?.date)}</p>
                    </div>
                </div>
            </div>
        </BackgroundImage>


    )
}
export default BlogPostHero;